import { IFetchResult, IFormStore } from 'src/core/classes/helpers/store/Interfaces'
import { updateQueries } from 'src/core/types/helpers/updateQueries'

import { createItem } from './createItem'
import { updateItem } from './updateItem'

export const mergeStoreData = <T, R>({
  dataStoreProp,
  keyField,
  query,
  data,
  groups,
  hierarchyField,
  closeExpandedRoot,
}: {
  dataStoreProp: IFormStore<T>
  keyField: string
  query: string
  data: IFetchResult<T>
  groups?: T[][]
  hierarchyField?: string
  closeExpandedRoot?: (root: R | null) => void
}) => {
  let dataStore = { ...dataStoreProp }
  const currentForm: T[] = dataStore.data || []
  const currentQueryValues: T[] = []
  data.items.forEach((row, curIndex) => {
    const ind = currentForm.findIndex((curRow) => curRow[keyField] === row[keyField])
    if (ind > -1) {
      currentQueryValues.push(currentForm[ind])
      updateItem<T, R>(
        dataStore,
        keyField,
        query,
        data,
        row,
        currentForm,
        ind,
        curIndex,
        hierarchyField,
        closeExpandedRoot
      )
    } else {
      currentQueryValues.push(row)
      createItem<T>(currentForm, row, query, dataStore, hierarchyField)
    }
  })
  dataStore.data = dataStore.data.slice()
  const queries = dataStore.queries

  if (!query) {
    updateQueries<T>({ queries, availableData: dataStore.data, hierarchyField })
  }

  data.items = currentQueryValues

  if (query && data && data.items) {
    data.groups = mergeQueryGroups(queries, query, keyField, hierarchyField, groups)
    queries[query] = data
    dataStore = {
      ...dataStore,
      queries,
    }
  }
  return {
    ...dataStore,
  }
}

export const mergeQueryGroups = <T>(
  queries: {
    [key: string]: IFetchResult<T>
  },
  query: string,
  keyField: string,
  hierarchyField?: string,
  groups?: T[][]
) => {
  const qGroups = queries[query] ? queries[query].groups || [] : []
  if (groups && hierarchyField) {
    let resultGroupsArray: T[][] = []
    const newGroups: T[][] = []
    if (qGroups) {
      resultGroupsArray = [...qGroups]
      groups.forEach((newGroup) => {
        const existedGroup = resultGroupsArray.find(
          (exGroup) => exGroup[0] && exGroup[0][hierarchyField] === newGroup[0][hierarchyField]
        )
        if (existedGroup) {
          newGroup.forEach((i) => {
            const findedItem = existedGroup.find((j) => j[keyField] === i[keyField])
            if (!findedItem) {
              existedGroup.push(i)
            }
          })
        } else {
          newGroups.push(newGroup)
        }
      })
    }
    resultGroupsArray = [...resultGroupsArray, ...newGroups]
    return resultGroupsArray
  }
  return qGroups || []
}
